import { Component, Input } from '@angular/core';
import { TranslateHelper } from '@app/_helpers';
import { Link } from '@interfaces/link';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { RouterLink } from '@angular/router';
import { NgFor, NgClass } from '@angular/common';

@Component({
    selector: 'app-footer-links',
    templateUrl: './links.component.html',
    styleUrls: ['./links.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgFor, RouterLink, NgClass, ExtendedModule, TranslateModule]
})
export class LinksComponent {
    @Input() header: string;
    @Input() links: any = [];
    showList: boolean = false;

    constructor(public translate: TranslateService,
        public translateHelper: TranslateHelper) { }
}
